// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CvcFOkZY6K0Mf3EQ {
  font: var(--lp-text-label-1-regular);
  gap: var(--lp-spacing-200);
  flex-direction: column;
  display: flex;
}

.CvcFOkZY6K0Mf3EQ input[data-rac]::-webkit-search-cancel-button {
  appearance: none;
}

.CvcFOkZY6K0Mf3EQ input[data-rac]::-webkit-search-decoration {
  appearance: none;
}

.CvcFOkZY6K0Mf3EQ[data-empty] button[tabindex="-1"] {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/SearchField.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EAKE,gBAAgB;AAClB;;AADA;EAIE,kBAAkB;AACpB","sourcesContent":[".search {\n  font: var(--lp-text-label-1-regular);\n  gap: var(--lp-spacing-200);\n  flex-direction: column;\n  display: flex;\n}\n\n.search input[data-rac]::-webkit-search-cancel-button, .search input[data-rac]::-webkit-search-decoration {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.search[data-empty] button[tabindex=\"-1\"] {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `CvcFOkZY6K0Mf3EQ`
};
export default ___CSS_LOADER_EXPORT___;
